// extracted by mini-css-extract-plugin
module.exports = {"root":"FormLoginPhone_root__3NxU3","field":"FormLoginPhone_field__aQ3ic","input":"FormLoginPhone_input__8ZG6f"};